// CRITICAL: Use window.ReactOnRails instead of import to avoid splitChunks
// creating separate module instances with separate component stores.
// See: https://github.com/shakacode/react_on_rails/issues/991
const reactOnRailsModule = require('react-on-rails');
window.ReactOnRails = window.ReactOnRails || reactOnRailsModule.default;
const ReactOnRails = window.ReactOnRails;

import ApiDocsApp from '../bundles/ApiDocs/startup/ApiDocsApp';

ReactOnRails.register({
  ApiDocsApp,
});
